"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTableToken = exports.TableConfig = void 0;
var Table_1 = __importDefault(require("@CommonFrontend/Public/Widgets/Table"));
var react_1 = __importDefault(require("react"));
var server_1 = __importDefault(require("react-dom/server"));
var lodash_1 = require("lodash");
var DefaultColors_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/DefaultColors");
var commonTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonTypes");
var Table_css_1 = require("../../ContentTokens/SharedWidgetComponents/Table/Table.css");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var pages_common_1 = require("@qwilr/pages-common");
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var Types_1 = require("@CommonFrontendBackend/Account/Types");
exports.TableConfig = {
    type: "table",
    publicRenderHtmlString: function (props) {
        return server_1.default.renderToString(react_1.default.createElement(Table_1.default, {
            columns: props.token.columns,
            columnBorders: props.token.columnBorders,
            cells: props.token.cells.map(function (row, index) {
                return row.map(function (row) {
                    return props.renderTokens(row, {
                        computeForegroundColor: function () {
                            if (index === 0 && props.style.header.on) {
                                return (0, pages_common_1.goldilocks)(props.style.header.color.abs, {
                                    mode: "text",
                                    foregroundColor: props.blockParagraphColor,
                                });
                            }
                            if (props.style.background.on) {
                                return (0, pages_common_1.goldilocks)(props.style.background.color.abs, {
                                    mode: "text",
                                    foregroundColor: props.blockParagraphColor,
                                });
                            }
                            return props.blockParagraphColor;
                        },
                    });
                });
            }),
            attributes: props.attributes,
            style: props.style,
        }));
    },
    tokenType: {},
    traits: {
        spacingShim: { className: "table-widget__spacing-shim" },
        selection: {
            dragHandleTop: "selection-ring",
        },
        styleable: {
            styleKey: "table",
            styleAccessKey: Types_1.StyleAccessType.ToolbarTable,
            properties: [
                {
                    type: "boolean",
                    label: "Top row color",
                    defaultValue: false,
                    path: "header.on",
                },
                {
                    type: "color",
                    label: "Top row color picker",
                    labelHidden: true,
                    defaultValue: { themeIndex: DefaultColors_1.DEFAULT_WHITE.themeIndex, value: DefaultColors_1.DEFAULT_WHITE.value },
                    path: "header.color",
                    variable: Table_css_1.vars.headerBackgroundColor,
                    if: function (elementStyles) {
                        return !!elementStyles["header"]["on"];
                    },
                    hugPreviousControl: true,
                },
                {
                    type: "boolean",
                    label: "Background color",
                    defaultValue: false,
                    path: "background.on",
                },
                {
                    type: "color",
                    label: "Background color picker",
                    labelHidden: true,
                    path: "background.color",
                    defaultValue: {
                        themeIndex: DefaultColors_1.DEFAULT_WHITE.themeIndex,
                        value: DefaultColors_1.DEFAULT_WHITE.value.toString(),
                    },
                    variable: Table_css_1.vars.backgroundColor,
                    if: function (elementStyles) {
                        return !!elementStyles["background"]["on"];
                    },
                    hugPreviousControl: true,
                },
                {
                    type: "enumerable",
                    label: "Border type",
                    path: "border.borderType",
                    options: [
                        {
                            label: "All table borders",
                            value: commonTypes_1.TableBorderType.All,
                            icon: icons_1.BordersAll,
                        },
                        {
                            label: "Horizontal table borders only",
                            value: commonTypes_1.TableBorderType.Horizontal,
                            icon: icons_1.BordersHorizontal,
                        },
                    ],
                    defaultValue: commonTypes_1.TableBorderType.All,
                },
                {
                    type: "color",
                    label: "Border color",
                    path: "border.color",
                    defaultValue: { themeIndex: -4 },
                    variable: Table_css_1.vars.borderColor,
                    opacity: {
                        label: "Border transparency",
                        defaultValue: 0.25,
                    },
                    presetColors: { type: "fixed", colors: DefaultColors_1.defaultBorderColors },
                },
            ],
            hideInToolbarInBlocks: [commonTypes_1.BlockType.Agreement],
        },
    },
    flattenForComments: function (currentToken, flattenedTokens) {
        (0, lodash_1.flattenDeep)(currentToken.cells).forEach(function (tableToken) {
            flattenedTokens.push(tableToken);
        });
    },
    tokenTraversers: {
        getFlatFromListOfTokens: function (token, runFlat) {
            var _a, _b, row, row_1, row_1_1, cell, _c, _d, cellToken, e_1_1, e_2_1, e_3_1;
            var e_3, _e, e_2, _f, e_1, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0: return [4, token];
                    case 1:
                        _h.sent();
                        _h.label = 2;
                    case 2:
                        _h.trys.push([2, 19, 20, 21]);
                        _a = __values(token.cells), _b = _a.next();
                        _h.label = 3;
                    case 3:
                        if (!!_b.done) return [3, 18];
                        row = _b.value;
                        _h.label = 4;
                    case 4:
                        _h.trys.push([4, 15, 16, 17]);
                        row_1 = (e_2 = void 0, __values(row)), row_1_1 = row_1.next();
                        _h.label = 5;
                    case 5:
                        if (!!row_1_1.done) return [3, 14];
                        cell = row_1_1.value;
                        _h.label = 6;
                    case 6:
                        _h.trys.push([6, 11, 12, 13]);
                        _c = (e_1 = void 0, __values(runFlat(cell))), _d = _c.next();
                        _h.label = 7;
                    case 7:
                        if (!!_d.done) return [3, 10];
                        cellToken = _d.value;
                        return [4, cellToken];
                    case 8:
                        _h.sent();
                        _h.label = 9;
                    case 9:
                        _d = _c.next();
                        return [3, 7];
                    case 10: return [3, 13];
                    case 11:
                        e_1_1 = _h.sent();
                        e_1 = { error: e_1_1 };
                        return [3, 13];
                    case 12:
                        try {
                            if (_d && !_d.done && (_g = _c.return)) _g.call(_c);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7];
                    case 13:
                        row_1_1 = row_1.next();
                        return [3, 5];
                    case 14: return [3, 17];
                    case 15:
                        e_2_1 = _h.sent();
                        e_2 = { error: e_2_1 };
                        return [3, 17];
                    case 16:
                        try {
                            if (row_1_1 && !row_1_1.done && (_f = row_1.return)) _f.call(row_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7];
                    case 17:
                        _b = _a.next();
                        return [3, 3];
                    case 18: return [3, 21];
                    case 19:
                        e_3_1 = _h.sent();
                        e_3 = { error: e_3_1 };
                        return [3, 21];
                    case 20:
                        try {
                            if (_b && !_b.done && (_e = _a.return)) _e.call(_a);
                        }
                        finally { if (e_3) throw e_3.error; }
                        return [7];
                    case 21: return [2];
                }
            });
        },
        getTransformedTokens: function (token, aggregateTokens, unpackAndTransformFn, transformFn) {
            token.cells.forEach(function (row, rowIndex) {
                row.forEach(function (cell, cellIndex) {
                    token.cells[rowIndex][cellIndex] = unpackAndTransformFn(cell);
                });
            });
            return __spreadArray(__spreadArray([], __read(aggregateTokens), false), __read(transformFn(token)), false);
        },
    },
};
var createTableToken = function (_a) {
    var rows = _a.rows, columns = _a.columns, cells = _a.cells, columnBorders = _a.columnBorders, style = _a.style;
    return __assign({ type: "block", subType: "table", rows: rows, columns: columns, columnBorders: columnBorders, cells: cells }, (0, CommonUtils_1.includeIf)(!!style, { style: style }));
};
exports.createTableToken = createTableToken;
